import { render, staticRenderFns } from "./CreateUserDialog.vue?vue&type=template&id=48305d02&scoped=true"
import script from "./CreateUserDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48305d02",
  null
  
)

export default component.exports